import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { StaticContents } from 'components/ServerSideComponents.jsx';
import { imagePath, rootLogo, rootIconAlt } from './images';

import animations from '../scss/components/animations.scss';
import styles from '../scss/partials/navigation.scss';

/*
 * This is the Navigation component that holds controls around
 * sorting/filtering the data in the infinite list
 *  - header at the top of the page
 *  - controls to open a sidebar
 *
 * @prop filters - the data fields that the list can be sorted by
 */
export default class Navigation extends Component {
	renderFilters() {
		const { filter, sectors } = this.props;

		let indicatorClass;
		let isActive;
		let linkClass;
		return sectors.map((sector, i) => {
			indicatorClass = classNames(styles.sectorIndicator, styles[sector]);
			isActive = filter && filter === sector;
			linkClass = classNames({ [styles.inactive]: !isActive, [styles.active]: isActive }, styles.sectorGroup);

			return (
				<a key={i} className={linkClass} onClick={(e) => this.props.updateFilter(sector, e)}>
					<div className={indicatorClass} />
					<div className={styles.sector}>{sector}</div>
				</a>
			);
		});
	}

	renderPeople() {
		const sortedElements = this.props.elements.sort((a, b) => {
			return a.fields.name > b.fields.name ? 1 : -1;
		});

		return sortedElements.map((person, i) => {
			return (
				<a key={i} className={styles.person} onClick={() => this.props.resetAndScrollIntoView(person.sys.id, person.fields.name)}>
					<div>{person.fields.name}</div>
				</a>
			);
		});
	}

	render() {
		const { filter, sidebarOpen } = this.props;

		const sidebarToggleClass = classNames({ [styles.sidebarOpen]: sidebarOpen, [styles[filter]]: filter }, styles.sidebarToggle);
		const resetFilterClass = classNames({ [styles.inactive]: filter, [styles.active]: !filter }, styles.sectorGroup);

		return (
			<div>
				<div className={classNames({ [styles.pushRight]: sidebarOpen }, styles.headerWrap)}>
					<ReactCSSTransitionGroup
						transitionName={{ appear: animations.appear, appearActive: animations.appearActive }}
						transitionAppear={true}
						transitionAppearTimeout={500}
						transitionLeaveTimeout={500}
						transitionEnterTimeout={500}>
						<div className={classNames({ [styles.pushRight]: sidebarOpen }, styles.header)}>
							<a className={sidebarToggleClass} onClick={this.props.toggleSidebar}>
								<div>
									<span className={styles.line}></span>
									<span className={styles.line}></span>
									<span className={styles.line}></span>
								</div>
							</a>
							<div className={styles.navInnerWrap}>
								<a href='http://www.theroot.com' className={styles.rootLogo} onClick={this.props.logoClick}>
									<StaticContents>
										<div>
											<img className={styles.mobileRootLogo} src={`${imagePath}${rootIconAlt}`} alt='Mobile Root Logo' />
											{rootLogo}
										</div>
									</StaticContents>
								</a>
							</div>
						</div>
					</ReactCSSTransitionGroup>
				</div>
				<div className={classNames({ [styles.isOpen]: sidebarOpen }, styles.sidebar)}>
					<h2>Filter By Sector</h2>
					<a className={resetFilterClass} onClick={(e) => this.props.updateFilter(undefined, e)}>
						<div className={styles.sectorIndicator} />
						<div className={styles.sector}>All</div>
					</a>
					{this.renderFilters()}
					<h2>Jump to Person</h2>
					<div className={styles.entryList}>
						{this.renderPeople()}
					</div>
				</div>
			</div>
		);
	}
}

Navigation.propTypes = {
	elements: PropTypes.array.isRequired,
	filter: PropTypes.string,
	sectors: PropTypes.array.isRequired,
	updateFilter: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/components/navigation.js